import { render, staticRenderFns } from "./TerimaView.vue?vue&type=template&id=fa44e42a&"
import script from "./TerimaView.vue?vue&type=script&lang=js&"
export * from "./TerimaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports